// See redirectUrlValidator.md - kept in sync manually with two other copies of this list.
export const ALLOWED_DOMAINS = [
  'vcita.com',
  'vchost.co',
  'townsquareinteractive.com',
  'thryv.com',
  'myclients.io',
  'marketingpro.sbtpg.com',
  'intandem.tech',
  'meet2know.com',
];

const isDomainAllowed = (hostname) => {
  if (!hostname) return false;
  const lowerHost = hostname.toLowerCase();
  return ALLOWED_DOMAINS.some((domain) => lowerHost === domain || lowerHost.endsWith(`.${domain}`));
};

export const isRedirectUrlAllowed = (url) => {
  if (!url) return false;

  let parsed;
  try {
    parsed = new URL(url, window.location.origin);
  } catch (e) {
    return false;
  }

  if (parsed.origin === window.location.origin) return true;
  return parsed.protocol === 'https:' && isDomainAllowed(parsed.hostname);
};

export default {
  ALLOWED_DOMAINS,
  isRedirectUrlAllowed,
};
